// import React, { useState } from 'react';
// import Icon from '../../../components/AppIcon';
// import Button from '../../../components/ui/Button';
// import api from '../../../api/axios';

// const CallHistoryLogTable = ({ onRowClick }) => {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [sortConfig, setSortConfig] = useState({ key: 'dateTime', direction: 'desc' });
//   const [editingTag, setEditingTag] = useState(null);
//   const [tagInput, setTagInput] = useState('');
//   const itemsPerPage = 10;

//   const callHistoryData = [
//     {
//       id: 'CALL-2026-001',
//       dateTime: '2026-01-02T10:30:00',
//       customerName: 'Sarah Johnson',
//       mobileNumber: '+1 (555) 123-4567',
//       concernCategory: 'Billing Issue',
//       conversationStatus: 'Resolved',
//       callDuration: 245,
//       recordingUrl: '#',
//       product: 'Premium Subscription',
//       ticketId: 'TKT-8472',
//       tags: ['urgent', 'refund-processed'],
//       conversation: [
//         { sender: 'customer', text: 'Hi, I was charged twice for my subscription.', time: '10:30', sentiment: 'negative' },
//         { sender: 'agent', text: 'I apologize for the inconvenience. Let me check your billing history.', time: '10:31', sentiment: 'neutral' },
//         { sender: 'agent', text: 'I can see the duplicate charge. Processing refund now.', time: '10:32', sentiment: 'positive' },
//         { sender: 'customer', text: 'Thank you! How long will it take?', time: '10:33', sentiment: 'positive' },
//         { sender: 'agent', text: 'Refund will appear in 3-5 business days.', time: '10:34', sentiment: 'positive' }
//       ],
//       metadata: {
//         orderId: 'ORD-2026-5421',
//         customerType: 'Repeat',
//         ticketsRaised: ['TKT-8472', 'TKT-8401'],
//         humanEscalation: 'No',
//         emailSent: true
//       }
//     },
//     {
//       id: 'CALL-2026-002',
//       dateTime: '2026-01-02T09:15:00',
//       customerName: 'Michael Chen',
//       mobileNumber: '+1 (555) 234-5678',
//       concernCategory: 'Account Management',
//       conversationStatus: 'Escalated',
//       callDuration: 420,
//       recordingUrl: '#',
//       product: 'Enterprise Plan',
//       ticketId: 'TKT-8473',
//       tags: ['escalated', 'technical'],
//       conversation: [
//         { sender: 'customer', text: 'I need to upgrade my account but the portal is not working.', time: '09:15', sentiment: 'negative' },
//         { sender: 'agent', text: 'Let me help you with that. Can you describe the issue?', time: '09:16', sentiment: 'neutral' },
//         { sender: 'customer', text: 'The upgrade button is grayed out.', time: '09:17', sentiment: 'negative' },
//         { sender: 'agent', text: 'This requires technical assistance. Connecting you to a specialist.', time: '09:20', sentiment: 'neutral' }
//       ],
//       metadata: {
//         orderId: 'ORD-2026-5422',
//         customerType: 'New',
//         ticketsRaised: ['TKT-8473'],
//         humanEscalation: 'Yes',
//         emailSent: true
//       }
//     },
//     {
//       id: 'CALL-2026-003',
//       dateTime: '2026-01-02T08:45:00',
//       customerName: 'Emily Rodriguez',
//       mobileNumber: '+1 (555) 345-6789',
//       concernCategory: 'Order Status',
//       conversationStatus: 'Resolved',
//       callDuration: 180,
//       recordingUrl: '#',
//       product: 'Wireless Headphones',
//       ticketId: null,
//       tags: ['tracking', 'delivery'],
//       conversation: [
//         { sender: 'customer', text: 'Where is my order? It was supposed to arrive yesterday.', time: '08:45', sentiment: 'negative' },
//         { sender: 'agent', text: 'Let me check the tracking information for you.', time: '08:46', sentiment: 'neutral' },
//         { sender: 'agent', text: 'Your order is out for delivery today. Expected by 5 PM.', time: '08:47', sentiment: 'positive' },
//         { sender: 'customer', text: 'Great, thank you!', time: '08:48', sentiment: 'positive' }
//       ],
//       metadata: {
//         orderId: 'ORD-2026-5423',
//         customerType: 'Repeat',
//         ticketsRaised: [],
//         humanEscalation: 'No',
//         emailSent: false
//       }
//     },
//     {
//       id: 'CALL-2026-004',
//       dateTime: '2026-01-01T16:20:00',
//       customerName: 'David Thompson',
//       mobileNumber: '+1 (555) 456-7890',
//       concernCategory: 'Cancellation',
//       conversationStatus: 'Pending',
//       callDuration: 312,
//       recordingUrl: '#',
//       product: 'Basic Plan',
//       ticketId: 'TKT-8474',
//       tags: ['cancellation', 'retention'],
//       conversation: [
//         { sender: 'customer', text: 'I want to cancel my subscription.', time: '16:20', sentiment: 'negative' },
//         { sender: 'agent', text: 'I understand. May I ask why you want to cancel?', time: '16:21', sentiment: 'neutral' },
//         { sender: 'customer', text: 'Not using it enough to justify the cost.', time: '16:22', sentiment: 'neutral' },
//         { sender: 'agent', text: 'Would you consider downgrading to a lower tier plan?', time: '16:23', sentiment: 'neutral' },
//         { sender: 'customer', text: 'Let me think about it.', time: '16:25', sentiment: 'neutral' }
//       ],
//       metadata: {
//         orderId: 'ORD-2026-5424',
//         customerType: 'Repeat',
//         ticketsRaised: ['TKT-8474'],
//         humanEscalation: 'No',
//         emailSent: true
//       }
//     },
//     {
//       id: 'CALL-2026-005',
//       dateTime: '2026-01-01T14:50:00',
//       customerName: 'Lisa Anderson',
//       mobileNumber: '+1 (555) 567-8901',
//       concernCategory: 'Exchange',
//       conversationStatus: 'Resolved',
//       callDuration: 267,
//       recordingUrl: '#',
//       product: 'Smart Watch',
//       ticketId: 'TKT-8475',
//       tags: ['exchange', 'size-issue'],
//       conversation: [
//         { sender: 'customer', text: 'I need to exchange my watch for a different size.', time: '14:50', sentiment: 'neutral' },
//         { sender: 'agent', text: 'No problem! What size would you like?', time: '14:51', sentiment: 'positive' },
//         { sender: 'customer', text: 'I need a medium instead of small.', time: '14:52', sentiment: 'neutral' },
//         { sender: 'agent', text: 'Exchange initiated. You will receive a prepaid return label via email.', time: '14:53', sentiment: 'positive' },
//         { sender: 'customer', text: 'Perfect, thank you!', time: '14:54', sentiment: 'positive' }
//       ],
//       metadata: {
//         orderId: 'ORD-2026-5425',
//         customerType: 'New',
//         ticketsRaised: ['TKT-8475'],
//         humanEscalation: 'No',
//         emailSent: true
//       }
//     },
//     {
//       id: 'CALL-2026-006',
//       dateTime: '2026-01-01T13:30:00',
//       customerName: 'James Wilson',
//       mobileNumber: '+1 (555) 678-9012',
//       concernCategory: 'Damaged Product',
//       conversationStatus: 'Escalated',
//       callDuration: 389,
//       recordingUrl: '#',
//       product: 'Laptop Stand',
//       ticketId: 'TKT-8476',
//       tags: ['damaged', 'replacement'],
//       conversation: [
//         { sender: 'customer', text: 'My laptop stand arrived damaged.', time: '13:30', sentiment: 'negative' },
//         { sender: 'agent', text: 'I am sorry to hear that. Can you describe the damage?', time: '13:31', sentiment: 'neutral' },
//         { sender: 'customer', text: 'The base is cracked and one leg is broken.', time: '13:32', sentiment: 'negative' },
//         { sender: 'agent', text: 'Let me escalate this for immediate replacement.', time: '13:35', sentiment: 'positive' }
//       ],
//       metadata: {
//         orderId: 'ORD-2026-5426',
//         customerType: 'Repeat',
//         ticketsRaised: ['TKT-8476'],
//         humanEscalation: 'Yes',
//         emailSent: true
//       }
//     },
//     {
//       id: 'CALL-2026-007',
//       dateTime: '2026-01-01T11:15:00',
//       customerName: 'Maria Garcia',
//       mobileNumber: '+1 (555) 789-0123',
//       concernCategory: 'Quality Complaint',
//       conversationStatus: 'Resolved',
//       callDuration: 198,
//       recordingUrl: '#',
//       product: 'Bluetooth Speaker',
//       ticketId: 'TKT-8477',
//       tags: ['quality', 'audio-issue'],
//       conversation: [
//         { sender: 'customer', text: 'The speaker sound quality is poor.', time: '11:15', sentiment: 'negative' },
//         { sender: 'agent', text: 'Let me help troubleshoot. Have you updated the firmware?', time: '11:16', sentiment: 'neutral' },
//         { sender: 'customer', text: 'No, how do I do that?', time: '11:17', sentiment: 'neutral' },
//         { sender: 'agent', text: 'I will send you instructions. This should improve the sound quality.', time: '11:18', sentiment: 'positive' },
//         { sender: 'customer', text: 'Okay, I will try that. Thanks!', time: '11:19', sentiment: 'positive' }
//       ],
//       metadata: {
//         orderId: 'ORD-2026-5427',
//         customerType: 'New',
//         ticketsRaised: ['TKT-8477'],
//         humanEscalation: 'No',
//         emailSent: true
//       }
//     },
//     {
//       id: 'CALL-2026-008',
//       dateTime: '2026-01-01T10:00:00',
//       customerName: 'Robert Taylor',
//       mobileNumber: '+1 (555) 890-1234',
//       concernCategory: 'Product Information',
//       conversationStatus: 'Resolved',
//       callDuration: 142,
//       recordingUrl: '#',
//       product: 'Gaming Mouse',
//       ticketId: null,
//       tags: ['product-info', 'specifications'],
//       conversation: [
//         { sender: 'customer', text: 'What is the DPI range for the gaming mouse?', time: '10:00', sentiment: 'neutral' },
//         { sender: 'agent', text: 'The gaming mouse has a DPI range of 400 to 16,000.', time: '10:01', sentiment: 'neutral' },
//         { sender: 'customer', text: 'Does it have programmable buttons?', time: '10:02', sentiment: 'neutral' },
//         { sender: 'agent', text: 'Yes, it has 8 programmable buttons with customizable RGB lighting.', time: '10:02', sentiment: 'positive' },
//         { sender: 'customer', text: 'Perfect, that is what I needed to know!', time: '10:03', sentiment: 'positive' }
//       ],
//       metadata: {
//         orderId: null,
//         customerType: 'Prospect',
//         ticketsRaised: [],
//         humanEscalation: 'No',
//         emailSent: false
//       }
//     },
//     {
//       id: 'CALL-2026-009',
//       dateTime: '2025-12-31T15:45:00',
//       customerName: 'Jennifer Lee',
//       mobileNumber: '+1 (555) 901-2345',
//       concernCategory: 'Service Issue',
//       conversationStatus: 'Escalated',
//       callDuration: 456,
//       recordingUrl: '#',
//       product: 'Cloud Storage',
//       ticketId: 'TKT-8478',
//       tags: ['service-outage', 'priority'],
//       conversation: [
//         { sender: 'customer', text: 'I cannot access my cloud storage. Is there an outage?', time: '15:45', sentiment: 'negative' },
//         { sender: 'agent', text: 'Let me check the service status for you.', time: '15:46', sentiment: 'neutral' },
//         { sender: 'agent', text: 'There is a temporary issue affecting some users. Our team is working on it.', time: '15:48', sentiment: 'neutral' },
//         { sender: 'customer', text: 'When will it be fixed? I need access urgently.', time: '15:49', sentiment: 'negative' },
//         { sender: 'agent', text: 'Escalating to technical team for priority resolution.', time: '15:51', sentiment: 'positive' }
//       ],
//       metadata: {
//         orderId: 'ORD-2026-5428',
//         customerType: 'Repeat',
//         ticketsRaised: ['TKT-8478', 'TKT-8450'],
//         humanEscalation: 'Yes',
//         emailSent: true
//       }
//     },
//     {
//       id: 'CALL-2026-010',
//       dateTime: '2025-12-31T14:20:00',
//       customerName: 'Christopher Brown',
//       mobileNumber: '+1 (555) 012-3456',
//       concernCategory: 'Billing Issue',
//       conversationStatus: 'Resolved',
//       callDuration: 223,
//       recordingUrl: '#',
//       product: 'Annual Membership',
//       ticketId: null,
//       tags: ['billing', 'invoice'],
//       conversation: [
//         { sender: 'customer', text: 'I need a copy of my invoice for tax purposes.', time: '14:20', sentiment: 'neutral' },
//         { sender: 'agent', text: 'I can help with that. Which invoice do you need?', time: '14:21', sentiment: 'neutral' },
//         { sender: 'customer', text: 'The one from December 2025.', time: '14:22', sentiment: 'neutral' },
//         { sender: 'agent', text: 'Sending the invoice to your registered email now.', time: '14:23', sentiment: 'positive' },
//         { sender: 'customer', text: 'Received it. Thank you!', time: '14:24', sentiment: 'positive' }
//       ],
//       metadata: {
//         orderId: 'ORD-2026-5429',
//         customerType: 'Repeat',
//         ticketsRaised: [],
//         humanEscalation: 'No',
//         emailSent: true
//       }
//     }
//   ];

//   const [callData, setCallData] = useState(callHistoryData);

//   const getStatusColor = (status) => {
//     const colors = {
//       'Resolved': 'bg-success/10 text-success border-success/20',
//       'Escalated': 'bg-warning/10 text-warning border-warning/20',
//       'Pending': 'bg-muted text-muted-foreground border-border',
//       'Abandoned': 'bg-error/10 text-error border-error/20'
//     };
//     return colors?.[status] || colors?.Pending;
//   };

//   const getStatusIcon = (status) => {
//     const icons = {
//       'Resolved': 'CheckCircle2',
//       'Escalated': 'ArrowUpCircle',
//       'Pending': 'Clock',
//       'Abandoned': 'XCircle'
//     };
//     return icons?.[status] || 'Clock';
//   };

//   const handleSort = (key) => {
//     setSortConfig({
//       key,
//       direction: sortConfig?.key === key && sortConfig?.direction === 'asc' ? 'desc' : 'asc'
//     });
//   };

//   const sortedData = [...callData]?.sort((a, b) => {
//     if (sortConfig?.key === 'dateTime') {
//       return sortConfig?.direction === 'asc'
//         ? new Date(a.dateTime) - new Date(b.dateTime)
//         : new Date(b.dateTime) - new Date(a.dateTime);
//     }
//     if (sortConfig?.key === 'callDuration') {
//       return sortConfig?.direction === 'asc'
//         ? a?.callDuration - b?.callDuration
//         : b?.callDuration - a?.callDuration;
//     }
//     if (sortConfig?.key === 'customerName') {
//       return sortConfig?.direction === 'asc'
//         ? a?.customerName?.localeCompare(b?.customerName)
//         : b?.customerName?.localeCompare(a?.customerName);
//     }
//     return 0;
//   });

//   const totalPages = Math.ceil(sortedData?.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const paginatedData = sortedData?.slice(startIndex, startIndex + itemsPerPage);

//   const formatDuration = (seconds) => {
//     const mins = Math.floor(seconds / 60);
//     const secs = seconds % 60;
//     return `${mins}m ${secs}s`;
//   };

//   const formatDateTime = (dateTime) => {
//     const date = new Date(dateTime);
//     return date?.toLocaleString('en-US', {
//       month: 'short',
//       day: 'numeric',
//       year: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit'
//     });
//   };

//   const handleAddTag = (callId, newTag) => {
//     if (newTag?.trim()) {
//       setCallData(prevData =>
//         prevData?.map(call =>
//           call?.id === callId
//             ? { ...call, tags: [...call?.tags, newTag?.trim()] }
//             : call
//         )
//       );
//       setTagInput('');
//       setEditingTag(null);
//     }
//   };

//   const handleRemoveTag = (callId, tagToRemove) => {
//     setCallData(prevData =>
//       prevData?.map(call =>
//         call?.id === callId
//           ? { ...call, tags: call?.tags?.filter(tag => tag !== tagToRemove) }
//           : call
//       )
//     );
//   };

//   return (
//     <div className="bg-card rounded-lg border border-border overflow-hidden">
//       <div className="p-4 md:p-6 border-b border-border">
//         <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
//           <div className="flex items-center gap-3">
//             <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-accent/10">
//               <Icon name="Phone" size={20} className="text-accent" />
//             </div>
//             <div>
//               <h3 className="text-base md:text-lg font-semibold text-foreground">Call History Log</h3>
//               <p className="text-xs md:text-sm text-muted-foreground">{callData?.length} total calls</p>
//             </div>
//           </div>
//           <div className="flex items-center gap-2">
//             <Button variant="outline" size="sm" iconName="Download" iconPosition="left">
//               Export
//             </Button>
//           </div>
//         </div>
//       </div>
//       <div className="overflow-x-auto">
//         <table className="w-full">
//           <thead className="bg-muted/50">
//             <tr>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <button
//                   onClick={() => handleSort('dateTime')}
//                   className="flex items-center gap-2 text-xs font-medium text-muted-foreground hover:text-foreground transition-base"
//                 >
//                   Date & Time
//                   <Icon name={sortConfig?.key === 'dateTime' && sortConfig?.direction === 'asc' ? 'ChevronUp' : 'ChevronDown'} size={14} />
//                 </button>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <button
//                   onClick={() => handleSort('customerName')}
//                   className="flex items-center gap-2 text-xs font-medium text-muted-foreground hover:text-foreground transition-base"
//                 >
//                   Customer Name
//                   <Icon name={sortConfig?.key === 'customerName' && sortConfig?.direction === 'asc' ? 'ChevronUp' : 'ChevronDown'} size={14} />
//                 </button>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <span className="text-xs font-medium text-muted-foreground">Mobile Number</span>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <span className="text-xs font-medium text-muted-foreground">Concern Category</span>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <span className="text-xs font-medium text-muted-foreground">Conversation Status</span>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <button
//                   onClick={() => handleSort('callDuration')}
//                   className="flex items-center gap-2 text-xs font-medium text-muted-foreground hover:text-foreground transition-base"
//                 >
//                   Call Duration
//                   <Icon name={sortConfig?.key === 'callDuration' && sortConfig?.direction === 'asc' ? 'ChevronUp' : 'ChevronDown'} size={14} />
//                 </button>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <span className="text-xs font-medium text-muted-foreground">Recording</span>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <span className="text-xs font-medium text-muted-foreground">Product</span>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <span className="text-xs font-medium text-muted-foreground">Ticket ID</span>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <span className="text-xs font-medium text-muted-foreground">Tags</span>
//               </th>
//             </tr>
//           </thead>
//           <tbody className="divide-y divide-border">
//             {paginatedData?.map((call) => (
//               <tr
//                 key={call?.id}
//                 onClick={() => onRowClick(call)}
//                 className="hover:bg-muted/30 transition-base cursor-pointer"
//               >
//                 <td className="px-4 md:px-6 py-4">
//                   <span className="text-sm text-foreground whitespace-nowrap">{formatDateTime(call?.dateTime)}</span>
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   <span className="text-sm font-medium text-foreground">{call?.customerName}</span>
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   <span className="text-sm text-foreground whitespace-nowrap">{call?.mobileNumber}</span>
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-muted text-xs font-medium text-foreground">
//                     {call?.concernCategory}
//                   </span>
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-medium ${getStatusColor(call?.conversationStatus)}`}>
//                     <Icon name={getStatusIcon(call?.conversationStatus)} size={12} />
//                     {call?.conversationStatus}
//                   </span>
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   <span className="text-sm text-foreground whitespace-nowrap">{formatDuration(call?.callDuration)}</span>
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   <button
//                     onClick={(e) => {
//                       e?.stopPropagation();
//                       // Play recording logic
//                     }}
//                     className="flex items-center justify-center w-8 h-8 rounded-lg bg-primary/10 hover:bg-primary hover:text-primary-foreground transition-base"
//                     aria-label="Play recording"
//                   >
//                     <Icon name="Play" size={14} />
//                   </button>
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   <span className="text-sm text-foreground">{call?.product}</span>
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   {call?.ticketId ? (
//                     <span className="text-sm font-mono text-primary">{call?.ticketId}</span>
//                   ) : (
//                     <span className="text-sm text-muted-foreground">-</span>
//                   )}
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   <div className="flex flex-wrap gap-1">
//                     {call?.tags?.map((tag, index) => (
//                       <span
//                         key={index}
//                         className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-primary/10 text-primary text-xs"
//                       >
//                         {tag}
//                         <button
//                           onClick={(e) => {
//                             e?.stopPropagation();
//                             handleRemoveTag(call?.id, tag);
//                           }}
//                           className="hover:text-error transition-base"
//                         >
//                           <Icon name="X" size={10} />
//                         </button>
//                       </span>
//                     ))}
//                     {editingTag === call?.id ? (
//                       <input
//                         type="text"
//                         value={tagInput}
//                         onChange={(e) => setTagInput(e?.target?.value)}
//                         onKeyDown={(e) => {
//                           if (e?.key === 'Enter') {
//                             handleAddTag(call?.id, tagInput);
//                           }
//                           if (e?.key === 'Escape') {
//                             setEditingTag(null);
//                             setTagInput('');
//                           }
//                         }}
//                         onBlur={() => {
//                           if (tagInput?.trim()) {
//                             handleAddTag(call?.id, tagInput);
//                           } else {
//                             setEditingTag(null);
//                           }
//                         }}
//                         onClick={(e) => e?.stopPropagation()}
//                         className="w-20 px-2 py-0.5 text-xs border border-border rounded-full focus:outline-none focus:ring-2 focus:ring-primary"
//                         placeholder="New tag"
//                         autoFocus
//                       />
//                     ) : (
//                       <button
//                         onClick={(e) => {
//                           e?.stopPropagation();
//                           setEditingTag(call?.id);
//                         }}
//                         className="flex items-center justify-center w-5 h-5 rounded-full bg-muted hover:bg-primary hover:text-primary-foreground transition-base"
//                       >
//                         <Icon name="Plus" size={10} />
//                       </button>
//                     )}
//                   </div>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//       <div className="flex flex-col sm:flex-row items-center justify-between gap-4 p-4 md:p-6 border-t border-border">
//         <p className="text-sm text-muted-foreground">
//           Showing {startIndex + 1} to {Math.min(startIndex + itemsPerPage, sortedData?.length)} of {sortedData?.length} calls
//         </p>
//         <div className="flex items-center gap-2">
//           <Button
//             variant="outline"
//             size="sm"
//             onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
//             disabled={currentPage === 1}
//           >
//             <Icon name="ChevronLeft" size={16} />
//           </Button>
//           <div className="flex items-center gap-1">
//             {[...Array(totalPages)]?.map((_, index) => (
//               <button
//                 key={index}
//                 onClick={() => setCurrentPage(index + 1)}
//                 className={`w-8 h-8 rounded-lg text-sm font-medium transition-base ${
//                   currentPage === index + 1
//                     ? 'bg-primary text-primary-foreground'
//                     : 'bg-muted text-muted-foreground hover:bg-primary/10'
//                 }`}
//               >
//                 {index + 1}
//               </button>
//             ))}
//           </div>
//           <Button
//             variant="outline"
//             size="sm"
//             onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
//             disabled={currentPage === totalPages}
//           >
//             <Icon name="ChevronRight" size={16} />
//           </Button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CallHistoryLogTable;

// import React, { useState, useEffect } from 'react';
// import Icon from '../../../components/AppIcon';
// import Button from '../../../components/ui/Button';
// import api from '../../../api/axios';

// const CallHistoryLogTable = ({ onRowClick }) => {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [sortConfig, setSortConfig] = useState({ key: 'dateTime', direction: 'desc' });
//   const [editingTag, setEditingTag] = useState(null);
//   const [tagInput, setTagInput] = useState('');
//   const [callData, setCallData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const itemsPerPage = 10;

//   // Fetch call history data from API
//   useEffect(() => {
//     const fetchCallHistory = async () => {
//       try {
//         setLoading(true);
//         setError(null);
//         const response = await api.get('/api/v1/dashboard/call-history');
        
//         if (response.data?.success && response.data?.data?.rows) {
//           // Transform API data to match component structure
//           const transformedData = response.data.data.rows.map((call, index) => ({
//             id: `CALL-${index + 1}`,
//             dateTime: call.dateTime,
//             customerName: call.customerName || 'NA',
//             mobileNumber: call.mobileNumber,
//             concernCategory: call.concernCategory || 'NA',
//             conversationStatus: call.conversationStatus,
//             callDuration: Math.round(call.callDurationMinutes * 60), // Convert minutes to seconds
//             recordingUrl: call.recordingUrl || '#',
//             product: call.productName || 'NA',
//             ticketId: null, // Not provided in API
//             tags: [],
//             callSummary: call.callSummary,
//             conversation: [], // Not provided in API
//             metadata: {
//               orderId: null,
//               customerType: call.customerName ? 'Repeat' : 'New',
//               ticketsRaised: [],
//               humanEscalation: 'No',
//               emailSent: false
//             }
//           }));
          
//           setCallData(transformedData);
//         }
//       } catch (err) {
//         console.error('Error fetching call history:', err);
//         setError('Failed to load call history data');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCallHistory();
//   }, []);

//   const getStatusColor = (status) => {
//     const colors = {
//       'completed': 'bg-success/10 text-success border-success/20',
//       'Resolved': 'bg-success/10 text-success border-success/20',
//       'Escalated': 'bg-warning/10 text-warning border-warning/20',
//       'Pending': 'bg-muted text-muted-foreground border-border',
//       'busy': 'bg-error/10 text-error border-error/20',
//       'Abandoned': 'bg-error/10 text-error border-error/20'
//     };
//     return colors?.[status] || colors?.Pending;
//   };

//   const getStatusIcon = (status) => {
//     const icons = {
//       'completed': 'CheckCircle2',
//       'Resolved': 'CheckCircle2',
//       'Escalated': 'ArrowUpCircle',
//       'Pending': 'Clock',
//       'busy': 'XCircle',
//       'Abandoned': 'XCircle'
//     };
//     return icons?.[status] || 'Clock';
//   };

//   const handleSort = (key) => {
//     setSortConfig({
//       key,
//       direction: sortConfig?.key === key && sortConfig?.direction === 'asc' ? 'desc' : 'asc'
//     });
//   };

//   const sortedData = [...callData]?.sort((a, b) => {
//     if (sortConfig?.key === 'dateTime') {
//       const dateA = new Date(a.dateTime);
//       const dateB = new Date(b.dateTime);
//       return sortConfig?.direction === 'asc' ? dateA - dateB : dateB - dateA;
//     }
//     if (sortConfig?.key === 'callDuration') {
//       return sortConfig?.direction === 'asc'
//         ? a?.callDuration - b?.callDuration
//         : b?.callDuration - a?.callDuration;
//     }
//     if (sortConfig?.key === 'customerName') {
//       return sortConfig?.direction === 'asc'
//         ? a?.customerName?.localeCompare(b?.customerName)
//         : b?.customerName?.localeCompare(a?.customerName);
//     }
//     return 0;
//   });

//   const totalPages = Math.ceil(sortedData?.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const paginatedData = sortedData?.slice(startIndex, startIndex + itemsPerPage);

//   const formatDuration = (seconds) => {
//     const mins = Math.floor(seconds / 60);
//     const secs = seconds % 60;
//     return `${mins}m ${secs}s`;
//   };

//   const formatDateTime = (dateTime) => {
//     // Handle the API format: "Jan 22, 2026, 05:55 pm"
//     try {
//       const date = new Date(dateTime);
//       if (isNaN(date.getTime())) {
//         return dateTime; // Return original if parsing fails
//       }
//       return date.toLocaleString('en-US', {
//         month: 'short',
//         day: 'numeric',
//         year: 'numeric',
//         hour: '2-digit',
//         minute: '2-digit'
//       });
//     } catch {
//       return dateTime;
//     }
//   };

//   const handleAddTag = (callId, newTag) => {
//     if (newTag?.trim()) {
//       setCallData(prevData =>
//         prevData?.map(call =>
//           call?.id === callId
//             ? { ...call, tags: [...call?.tags, newTag?.trim()] }
//             : call
//         )
//       );
//       setTagInput('');
//       setEditingTag(null);
//     }
//   };

//   const handleRemoveTag = (callId, tagToRemove) => {
//     setCallData(prevData =>
//       prevData?.map(call =>
//         call?.id === callId
//           ? { ...call, tags: call?.tags?.filter(tag => tag !== tagToRemove) }
//           : call
//       )
//     );
//   };

//   if (loading) {
//     return (
//       <div className="bg-card rounded-lg border border-border overflow-hidden">
//         <div className="p-8 flex items-center justify-center">
//           <div className="flex items-center gap-3">
//             <div className="w-5 h-5 border-2 border-primary border-t-transparent rounded-full animate-spin"></div>
//             <span className="text-muted-foreground">Loading call history...</span>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="bg-card rounded-lg border border-border overflow-hidden">
//         <div className="p-8 flex flex-col items-center justify-center gap-4">
//           <Icon name="AlertCircle" size={48} className="text-error" />
//           <div className="text-center">
//             <p className="text-foreground font-medium mb-1">Failed to load call history</p>
//             <p className="text-sm text-muted-foreground">{error}</p>
//           </div>
//           <Button onClick={() => window.location.reload()} variant="outline" size="sm">
//             Retry
//           </Button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-card rounded-lg border border-border overflow-hidden">
//       <div className="p-4 md:p-6 border-b border-border">
//         <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
//           <div className="flex items-center gap-3">
//             <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-accent/10">
//               <Icon name="Phone" size={20} className="text-accent" />
//             </div>
//             <div>
//               <h3 className="text-base md:text-lg font-semibold text-foreground">Call History Log</h3>
//               <p className="text-xs md:text-sm text-muted-foreground">{callData?.length} total calls</p>
//             </div>
//           </div>
//           <div className="flex items-center gap-2">
//             <Button variant="outline" size="sm" iconName="Download" iconPosition="left">
//               Export
//             </Button>
//           </div>
//         </div>
//       </div>
//       <div className="overflow-x-auto">
//         <table className="w-full">
//           <thead className="bg-muted/50">
//             <tr>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <button
//                   onClick={() => handleSort('dateTime')}
//                   className="flex items-center gap-2 text-xs font-medium text-muted-foreground hover:text-foreground transition-base"
//                 >
//                   Date & Time
//                   <Icon name={sortConfig?.key === 'dateTime' && sortConfig?.direction === 'asc' ? 'ChevronUp' : 'ChevronDown'} size={14} />
//                 </button>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <button
//                   onClick={() => handleSort('customerName')}
//                   className="flex items-center gap-2 text-xs font-medium text-muted-foreground hover:text-foreground transition-base"
//                 >
//                   Customer Name
//                   <Icon name={sortConfig?.key === 'customerName' && sortConfig?.direction === 'asc' ? 'ChevronUp' : 'ChevronDown'} size={14} />
//                 </button>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <span className="text-xs font-medium text-muted-foreground">Mobile Number</span>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <span className="text-xs font-medium text-muted-foreground">Concern Category</span>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <span className="text-xs font-medium text-muted-foreground">Conversation Status</span>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <button
//                   onClick={() => handleSort('callDuration')}
//                   className="flex items-center gap-2 text-xs font-medium text-muted-foreground hover:text-foreground transition-base"
//                 >
//                   Call Duration
//                   <Icon name={sortConfig?.key === 'callDuration' && sortConfig?.direction === 'asc' ? 'ChevronUp' : 'ChevronDown'} size={14} />
//                 </button>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <span className="text-xs font-medium text-muted-foreground">Recording</span>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <span className="text-xs font-medium text-muted-foreground">Product</span>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <span className="text-xs font-medium text-muted-foreground">Ticket ID</span>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <span className="text-xs font-medium text-muted-foreground">Tags</span>
//               </th>
//             </tr>
//           </thead>
//           <tbody className="divide-y divide-border">
//             {paginatedData?.map((call) => (
//               <tr
//                 key={call?.id}
//                 onClick={() => onRowClick(call)}
//                 className="hover:bg-muted/30 transition-base cursor-pointer"
//               >
//                 <td className="px-4 md:px-6 py-4">
//                   <span className="text-sm text-foreground whitespace-nowrap">{formatDateTime(call?.dateTime)}</span>
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   <span className="text-sm font-medium text-foreground">{call?.customerName}</span>
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   <span className="text-sm text-foreground whitespace-nowrap">{call?.mobileNumber}</span>
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-muted text-xs font-medium text-foreground">
//                     {call?.concernCategory}
//                   </span>
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-medium ${getStatusColor(call?.conversationStatus)}`}>
//                     <Icon name={getStatusIcon(call?.conversationStatus)} size={12} />
//                     {call?.conversationStatus}
//                   </span>
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   <span className="text-sm text-foreground whitespace-nowrap">{formatDuration(call?.callDuration)}</span>
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   {call?.recordingUrl && call?.recordingUrl !== '#' ? (
//                     <button
//                       onClick={(e) => {
//                         e?.stopPropagation();
//                         window.open(call?.recordingUrl, '_blank');
//                       }}
//                       className="flex items-center justify-center w-8 h-8 rounded-lg bg-primary/10 hover:bg-primary hover:text-primary-foreground transition-base"
//                       aria-label="Play recording"
//                     >
//                       <Icon name="Play" size={14} />
//                     </button>
//                   ) : (
//                     <span className="text-sm text-muted-foreground">-</span>
//                   )}
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   <span className="text-sm text-foreground">{call?.product}</span>
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   {call?.ticketId ? (
//                     <span className="text-sm font-mono text-primary">{call?.ticketId}</span>
//                   ) : (
//                     <span className="text-sm text-muted-foreground">-</span>
//                   )}
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   <div className="flex flex-wrap gap-1">
//                     {call?.tags?.map((tag, index) => (
//                       <span
//                         key={index}
//                         className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-primary/10 text-primary text-xs"
//                       >
//                         {tag}
//                         <button
//                           onClick={(e) => {
//                             e?.stopPropagation();
//                             handleRemoveTag(call?.id, tag);
//                           }}
//                           className="hover:text-error transition-base"
//                         >
//                           <Icon name="X" size={10} />
//                         </button>
//                       </span>
//                     ))}
//                     {editingTag === call?.id ? (
//                       <input
//                         type="text"
//                         value={tagInput}
//                         onChange={(e) => setTagInput(e?.target?.value)}
//                         onKeyDown={(e) => {
//                           if (e?.key === 'Enter') {
//                             handleAddTag(call?.id, tagInput);
//                           }
//                           if (e?.key === 'Escape') {
//                             setEditingTag(null);
//                             setTagInput('');
//                           }
//                         }}
//                         onBlur={() => {
//                           if (tagInput?.trim()) {
//                             handleAddTag(call?.id, tagInput);
//                           } else {
//                             setEditingTag(null);
//                           }
//                         }}
//                         onClick={(e) => e?.stopPropagation()}
//                         className="w-20 px-2 py-0.5 text-xs border border-border rounded-full focus:outline-none focus:ring-2 focus:ring-primary"
//                         placeholder="New tag"
//                         autoFocus
//                       />
//                     ) : (
//                       <button
//                         onClick={(e) => {
//                           e?.stopPropagation();
//                           setEditingTag(call?.id);
//                         }}
//                         className="flex items-center justify-center w-5 h-5 rounded-full bg-muted hover:bg-primary hover:text-primary-foreground transition-base"
//                       >
//                         <Icon name="Plus" size={10} />
//                       </button>
//                     )}
//                   </div>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//       <div className="flex flex-col sm:flex-row items-center justify-between gap-4 p-4 md:p-6 border-t border-border">
//         <p className="text-sm text-muted-foreground">
//           Showing {startIndex + 1} to {Math.min(startIndex + itemsPerPage, sortedData?.length)} of {sortedData?.length} calls
//         </p>
//         <div className="flex items-center gap-2">
//           <Button
//             variant="outline"
//             size="sm"
//             onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
//             disabled={currentPage === 1}
//           >
//             <Icon name="ChevronLeft" size={16} />
//           </Button>
//           <div className="flex items-center gap-1">
//             {[...Array(totalPages)]?.map((_, index) => (
//               <button
//                 key={index}
//                 onClick={() => setCurrentPage(index + 1)}
//                 className={`w-8 h-8 rounded-lg text-sm font-medium transition-base ${
//                   currentPage === index + 1
//                     ? 'bg-primary text-primary-foreground'
//                     : 'bg-muted text-muted-foreground hover:bg-primary/10'
//                 }`}
//               >
//                 {index + 1}
//               </button>
//             ))}
//           </div>
//           <Button
//             variant="outline"
//             size="sm"
//             onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
//             disabled={currentPage === totalPages}
//           >
//             <Icon name="ChevronRight" size={16} />
//           </Button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CallHistoryLogTable;


// import React, { useState, useEffect } from 'react';
// import Icon from '../../../components/AppIcon';
// import Button from '../../../components/ui/Button';
// import api from '../../../api/axios';

// const CallHistoryLogTable = ({ onRowClick }) => {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [sortConfig, setSortConfig] = useState({ key: 'dateTime', direction: 'desc' });
//   const [editingTag, setEditingTag] = useState(null);
//   const [tagInput, setTagInput] = useState('');
//   const [callData, setCallData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const itemsPerPage = 10;

//   // Fetch call history data from API
//   useEffect(() => {
//     const fetchCallHistory = async () => {
//       try {
//         setLoading(true);
//         setError(null);
//         const response = await api.get('/api/v1/dashboard/call-history');
        
//         if (response.data?.success && response.data?.data?.rows) {
//           // Transform API data to match component structure
//           const transformedData = response.data.data.rows.map((call, index) => ({
//             id: `CALL-${index + 1}`,
//             callId: call.callId, // Store the actual callId for API calls
//             dateTime: call.dateTime,
//             customerName: call.customerName || 'NA',
//             mobileNumber: call.mobileNumber,
//             concernCategory: call.concernCategory || 'NA',
//             conversationStatus: call.conversationStatus,
//             callDuration: Math.round(call.callDurationMinutes * 60), // Convert minutes to seconds
//             recordingUrl: call.recordingUrl || '#',
//             product: call.productName || 'NA',
//             ticketId: null, // Not provided in API
//             tags: [],
//             callSummary: call.callSummary,
//             conversation: [], // Will be loaded on demand
//             metadata: {
//               orderId: null,
//               customerType: call.customerName ? 'Repeat' : 'New',
//               ticketsRaised: [],
//               humanEscalation: 'No',
//               emailSent: false
//             }
//           }));
          
//           setCallData(transformedData);
//         }
//       } catch (err) {
//         console.error('Error fetching call history:', err);
//         setError('Failed to load call history data');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCallHistory();
//   }, []);

//   // Fetch detailed call data when row is clicked
//   const handleRowClick = async (call) => {
//     try {
//       // If call details already loaded, just trigger the parent callback
//       if (call.conversation?.length > 0) {
//         onRowClick(call);
//         return;
//       }

//       // Fetch call details from API
//       const response = await api.get(`/api/v1/dashboard/call-details/${call.callId}`);
      
//       if (response.data?.success && response.data?.data) {
//         const details = response.data.data;
        
//         // Transform conversation thread
//         const conversation = details.conversationThread?.map(msg => ({
//           sender: msg.speaker.toLowerCase(),
//           text: msg.message,
//           time: msg.time,
//           sentiment: msg.sentiment
//         })) || [];

//         // Update call data with detailed information
//         const enrichedCall = {
//           ...call,
//           conversation,
//           metadata: {
//             orderId: details.orderId || null,
//             customerType: details.customerType || 'New',
//             ticketsRaised: details.ticketsRaised || [],
//             humanEscalation: details.humanEscalation ? 'Yes' : 'No',
//             emailSent: details.emailSent || false
//           }
//         };

//         // Update the call in state
//         setCallData(prevData =>
//           prevData.map(c => c.id === call.id ? enrichedCall : c)
//         );

//         // Trigger parent callback with enriched data
//         onRowClick(enrichedCall);
//       }
//     } catch (err) {
//       console.error('Error fetching call details:', err);
//       // Still trigger callback with original data on error
//       onRowClick(call);
//     }
//   };

//   const getStatusColor = (status) => {
//     const colors = {
//       'completed': 'bg-success/10 text-success border-success/20',
//       'Resolved': 'bg-success/10 text-success border-success/20',
//       'Escalated': 'bg-warning/10 text-warning border-warning/20',
//       'Pending': 'bg-muted text-muted-foreground border-border',
//       'busy': 'bg-error/10 text-error border-error/20',
//       'Abandoned': 'bg-error/10 text-error border-error/20'
//     };
//     return colors?.[status] || colors?.Pending;
//   };

//   const getStatusIcon = (status) => {
//     const icons = {
//       'completed': 'CheckCircle2',
//       'Resolved': 'CheckCircle2',
//       'Escalated': 'ArrowUpCircle',
//       'Pending': 'Clock',
//       'busy': 'XCircle',
//       'Abandoned': 'XCircle'
//     };
//     return icons?.[status] || 'Clock';
//   };

//   const handleSort = (key) => {
//     setSortConfig({
//       key,
//       direction: sortConfig?.key === key && sortConfig?.direction === 'asc' ? 'desc' : 'asc'
//     });
//   };

//   const sortedData = [...callData]?.sort((a, b) => {
//     if (sortConfig?.key === 'dateTime') {
//       const dateA = new Date(a.dateTime);
//       const dateB = new Date(b.dateTime);
//       return sortConfig?.direction === 'asc' ? dateA - dateB : dateB - dateA;
//     }
//     if (sortConfig?.key === 'callDuration') {
//       return sortConfig?.direction === 'asc'
//         ? a?.callDuration - b?.callDuration
//         : b?.callDuration - a?.callDuration;
//     }
//     if (sortConfig?.key === 'customerName') {
//       return sortConfig?.direction === 'asc'
//         ? a?.customerName?.localeCompare(b?.customerName)
//         : b?.customerName?.localeCompare(a?.customerName);
//     }
//     return 0;
//   });

//   const totalPages = Math.ceil(sortedData?.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const paginatedData = sortedData?.slice(startIndex, startIndex + itemsPerPage);

//   const formatDuration = (seconds) => {
//     const mins = Math.floor(seconds / 60);
//     const secs = seconds % 60;
//     return `${mins}m ${secs}s`;
//   };

//   const formatDateTime = (dateTime) => {
//     // Handle the API format: "Jan 22, 2026, 05:55 pm"
//     try {
//       const date = new Date(dateTime);
//       if (isNaN(date.getTime())) {
//         return dateTime; // Return original if parsing fails
//       }
//       return date.toLocaleString('en-US', {
//         month: 'short',
//         day: 'numeric',
//         year: 'numeric',
//         hour: '2-digit',
//         minute: '2-digit'
//       });
//     } catch {
//       return dateTime;
//     }
//   };

//   const handleAddTag = (callId, newTag) => {
//     if (newTag?.trim()) {
//       setCallData(prevData =>
//         prevData?.map(call =>
//           call?.id === callId
//             ? { ...call, tags: [...call?.tags, newTag?.trim()] }
//             : call
//         )
//       );
//       setTagInput('');
//       setEditingTag(null);
//     }
//   };

//   const handleRemoveTag = (callId, tagToRemove) => {
//     setCallData(prevData =>
//       prevData?.map(call =>
//         call?.id === callId
//           ? { ...call, tags: call?.tags?.filter(tag => tag !== tagToRemove) }
//           : call
//       )
//     );
//   };

//   if (loading) {
//     return (
//       <div className="bg-card rounded-lg border border-border overflow-hidden">
//         <div className="p-8 flex items-center justify-center">
//           <div className="flex items-center gap-3">
//             <div className="w-5 h-5 border-2 border-primary border-t-transparent rounded-full animate-spin"></div>
//             <span className="text-muted-foreground">Loading call history...</span>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="bg-card rounded-lg border border-border overflow-hidden">
//         <div className="p-8 flex flex-col items-center justify-center gap-4">
//           <Icon name="AlertCircle" size={48} className="text-error" />
//           <div className="text-center">
//             <p className="text-foreground font-medium mb-1">Failed to load call history</p>
//             <p className="text-sm text-muted-foreground">{error}</p>
//           </div>
//           <Button onClick={() => window.location.reload()} variant="outline" size="sm">
//             Retry
//           </Button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-card rounded-lg border border-border overflow-hidden">
//       <div className="p-4 md:p-6 border-b border-border">
//         <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
//           <div className="flex items-center gap-3">
//             <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-accent/10">
//               <Icon name="Phone" size={20} className="text-accent" />
//             </div>
//             <div>
//               <h3 className="text-base md:text-lg font-semibold text-foreground">Call History Log</h3>
//               <p className="text-xs md:text-sm text-muted-foreground">{callData?.length} total calls</p>
//             </div>
//           </div>
//           <div className="flex items-center gap-2">
//             <Button variant="outline" size="sm" iconName="Download" iconPosition="left">
//               Export
//             </Button>
//           </div>
//         </div>
//       </div>
//       <div className="overflow-x-auto">
//         <table className="w-full">
//           <thead className="bg-muted/50">
//             <tr>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <button
//                   onClick={() => handleSort('dateTime')}
//                   className="flex items-center gap-2 text-xs font-medium text-muted-foreground hover:text-foreground transition-base"
//                 >
//                   Date & Time
//                   <Icon name={sortConfig?.key === 'dateTime' && sortConfig?.direction === 'asc' ? 'ChevronUp' : 'ChevronDown'} size={14} />
//                 </button>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <button
//                   onClick={() => handleSort('customerName')}
//                   className="flex items-center gap-2 text-xs font-medium text-muted-foreground hover:text-foreground transition-base"
//                 >
//                   Customer Name
//                   <Icon name={sortConfig?.key === 'customerName' && sortConfig?.direction === 'asc' ? 'ChevronUp' : 'ChevronDown'} size={14} />
//                 </button>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <span className="text-xs font-medium text-muted-foreground">Mobile Number</span>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <span className="text-xs font-medium text-muted-foreground">Concern Category</span>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <span className="text-xs font-medium text-muted-foreground">Conversation Status</span>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <button
//                   onClick={() => handleSort('callDuration')}
//                   className="flex items-center gap-2 text-xs font-medium text-muted-foreground hover:text-foreground transition-base"
//                 >
//                   Call Duration
//                   <Icon name={sortConfig?.key === 'callDuration' && sortConfig?.direction === 'asc' ? 'ChevronUp' : 'ChevronDown'} size={14} />
//                 </button>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <span className="text-xs font-medium text-muted-foreground">Recording</span>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <span className="text-xs font-medium text-muted-foreground">Product</span>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <span className="text-xs font-medium text-muted-foreground">Ticket ID</span>
//               </th>
//               <th className="px-4 md:px-6 py-3 text-left">
//                 <span className="text-xs font-medium text-muted-foreground">Tags</span>
//               </th>
//             </tr>
//           </thead>
//           <tbody className="divide-y divide-border">
//             {paginatedData?.map((call) => (
//               <tr
//                 key={call?.id}
//                 onClick={() => handleRowClick(call)}
//                 className="hover:bg-muted/30 transition-base cursor-pointer"
//               >
//                 <td className="px-4 md:px-6 py-4">
//                   <span className="text-sm text-foreground whitespace-nowrap">{formatDateTime(call?.dateTime)}</span>
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   <span className="text-sm font-medium text-foreground">{call?.customerName}</span>
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   <span className="text-sm text-foreground whitespace-nowrap">{call?.mobileNumber}</span>
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-muted text-xs font-medium text-foreground">
//                     {call?.concernCategory}
//                   </span>
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-medium ${getStatusColor(call?.conversationStatus)}`}>
//                     <Icon name={getStatusIcon(call?.conversationStatus)} size={12} />
//                     {call?.conversationStatus}
//                   </span>
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   <span className="text-sm text-foreground whitespace-nowrap">{formatDuration(call?.callDuration)}</span>
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   {call?.recordingUrl && call?.recordingUrl !== '#' ? (
//                     <button
//                       onClick={(e) => {
//                         e?.stopPropagation();
//                         window.open(call?.recordingUrl, '_blank');
//                       }}
//                       className="flex items-center justify-center w-8 h-8 rounded-lg bg-primary/10 hover:bg-primary hover:text-primary-foreground transition-base"
//                       aria-label="Play recording"
//                     >
//                       <Icon name="Play" size={14} />
//                     </button>
//                   ) : (
//                     <span className="text-sm text-muted-foreground">-</span>
//                   )}
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   <span className="text-sm text-foreground">{call?.product}</span>
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   {call?.ticketId ? (
//                     <span className="text-sm font-mono text-primary">{call?.ticketId}</span>
//                   ) : (
//                     <span className="text-sm text-muted-foreground">-</span>
//                   )}
//                 </td>
//                 <td className="px-4 md:px-6 py-4">
//                   <div className="flex flex-wrap gap-1">
//                     {call?.tags?.map((tag, index) => (
//                       <span
//                         key={index}
//                         className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-primary/10 text-primary text-xs"
//                       >
//                         {tag}
//                         <button
//                           onClick={(e) => {
//                             e?.stopPropagation();
//                             handleRemoveTag(call?.id, tag);
//                           }}
//                           className="hover:text-error transition-base"
//                         >
//                           <Icon name="X" size={10} />
//                         </button>
//                       </span>
//                     ))}
//                     {editingTag === call?.id ? (
//                       <input
//                         type="text"
//                         value={tagInput}
//                         onChange={(e) => setTagInput(e?.target?.value)}
//                         onKeyDown={(e) => {
//                           if (e?.key === 'Enter') {
//                             handleAddTag(call?.id, tagInput);
//                           }
//                           if (e?.key === 'Escape') {
//                             setEditingTag(null);
//                             setTagInput('');
//                           }
//                         }}
//                         onBlur={() => {
//                           if (tagInput?.trim()) {
//                             handleAddTag(call?.id, tagInput);
//                           } else {
//                             setEditingTag(null);
//                           }
//                         }}
//                         onClick={(e) => e?.stopPropagation()}
//                         className="w-20 px-2 py-0.5 text-xs border border-border rounded-full focus:outline-none focus:ring-2 focus:ring-primary"
//                         placeholder="New tag"
//                         autoFocus
//                       />
//                     ) : (
//                       <button
//                         onClick={(e) => {
//                           e?.stopPropagation();
//                           setEditingTag(call?.id);
//                         }}
//                         className="flex items-center justify-center w-5 h-5 rounded-full bg-muted hover:bg-primary hover:text-primary-foreground transition-base"
//                       >
//                         <Icon name="Plus" size={10} />
//                       </button>
//                     )}
//                   </div>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//       <div className="flex flex-col sm:flex-row items-center justify-between gap-4 p-4 md:p-6 border-t border-border">
//         <p className="text-sm text-muted-foreground">
//           Showing {startIndex + 1} to {Math.min(startIndex + itemsPerPage, sortedData?.length)} of {sortedData?.length} calls
//         </p>
//         <div className="flex items-center gap-2">
//           <Button
//             variant="outline"
//             size="sm"
//             onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
//             disabled={currentPage === 1}
//           >
//             <Icon name="ChevronLeft" size={16} />
//           </Button>
//           <div className="flex items-center gap-1">
//             {[...Array(totalPages)]?.map((_, index) => (
//               <button
//                 key={index}
//                 onClick={() => setCurrentPage(index + 1)}
//                 className={`w-8 h-8 rounded-lg text-sm font-medium transition-base ${
//                   currentPage === index + 1
//                     ? 'bg-primary text-primary-foreground'
//                     : 'bg-muted text-muted-foreground hover:bg-primary/10'
//                 }`}
//               >
//                 {index + 1}
//               </button>
//             ))}
//           </div>
//           <Button
//             variant="outline"
//             size="sm"
//             onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
//             disabled={currentPage === totalPages}
//           >
//             <Icon name="ChevronRight" size={16} />
//           </Button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CallHistoryLogTable;


import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import api from '../../../api/axios';

const DATE_OPTIONS = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'last7', label: 'Last 7 Days' },
  { value: 'last30', label: 'Last 30 Days' },
  { value: 'lastMonth', label: 'Last Month' },
  { value: 'allTime', label: 'All Time' },
  { value: 'custom', label: 'Custom' },
];

const getDateRange = (dateRange, customFrom, customTo) => {
  const now = new Date();
  let from = new Date();
  let to = new Date();
  if (dateRange === 'yesterday') {
    from.setDate(now.getDate() - 1);
    to.setDate(now.getDate() - 1);
  } else if (dateRange === 'last7') {
    from.setDate(now.getDate() - 6);
  } else if (dateRange === 'last30') {
    from.setDate(now.getDate() - 29);
  } else if (dateRange === 'lastMonth') {
    from = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    to = new Date(now.getFullYear(), now.getMonth(), 0);
  } else if (dateRange === 'custom' && customFrom && customTo) {
    from = new Date(customFrom);
    to = new Date(customTo);
  } else if (dateRange === 'allTime') {
    from.setFullYear(now.getFullYear() - 2);
  }
  // else 'today' — from and to are already today
  from.setHours(0, 0, 0, 0);
  to.setHours(23, 59, 59, 999);
  const fmt = (d) => d.toISOString().split('.')[0];
  return { from: fmt(from), to: fmt(to) };
};

// Call status filter. Applied in the browser: the call-history API has no status parameter,
// so with a status selected the calls for the current range are loaded (up to the limit)
// and filtered / paginated locally.
const CALL_STATUS_OPTIONS = [
  { value: 'completed', label: 'Completed', match: ['completed'] },
  { value: 'no-answer', label: 'No Answer', match: ['no-answer', 'no_answer'] },
  { value: 'busy', label: 'Busy', match: ['busy'] },
  { value: 'failed', label: 'Failed', match: ['failed'] },
  { value: 'in-progress', label: 'In Progress', match: ['active', 'in-progress', 'ringing', 'initiated'] },
];
const STATUS_FILTER_FETCH_LIMIT = 2000;

const matchesCallStatus = (status, filter) => {
  const option = CALL_STATUS_OPTIONS.find((o) => o.value === filter);
  return !option || option.match.includes(String(status || '').toLowerCase());
};

const CallHistoryLogTable = forwardRef(({ onRowClick }, ref) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: 'dateTime', direction: 'desc' });
  const [editingTag, setEditingTag] = useState(null);
  const [tagInput, setTagInput] = useState('');
  const [callData, setCallData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [playingUrl, setPlayingUrl] = useState(null);
  const [totalCalls, setTotalCalls] = useState(0);
  const [agents, setAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState('');
  const [searchPhone, setSearchPhone] = useState('');
  const [phoneQuery, setPhoneQuery] = useState('');
  const [dateRange, setDateRange] = useState('today');
  const [dateOpen, setDateOpen] = useState(false);
  const [customFrom, setCustomFrom] = useState('');
  const [customTo, setCustomTo] = useState('');
  const [tags, setTags] = useState([]);
  const [selectedTag, setSelectedTag] = useState('');
  const [selectedReview, setSelectedReview] = useState('');
  const [selectedEscalation, setSelectedEscalation] = useState('');
  const [selectedEscalationStatus, setSelectedEscalationStatus] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [statusFilterCapped, setStatusFilterCapped] = useState(false);
  const phoneTimerRef = useRef(null);
  const dateRef = useRef(null);
  const itemsPerPage = 10;

  const range = getDateRange(dateRange, customFrom, customTo);
  const from = range.from;
  const to = range.to;

  useEffect(() => {
    api.get('/api/v1/dashboard/get-agents')
      .then((res) => {
        const list = res.data?.data?.agents || [];
        setAgents(list);
      })
      .catch((err) => console.error('Failed to fetch agents:', err));
    api.get('/api/v1/dashboard/tags')
      .then((res) => {
        const list = res.data?.data || [];
        setTags(list);
      })
      .catch((err) => console.error('Failed to fetch tags:', err));
  }, []);

  useEffect(() => {
    const handler = (e) => {
      if (dateRef.current && !dateRef.current.contains(e.target)) setDateOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const selectedDateLabel =
    dateRange === 'custom' && customFrom && customTo
      ? `${customFrom} → ${customTo}`
      : DATE_OPTIONS.find((d) => d.value === dateRange)?.label || 'Today';

  useImperativeHandle(ref, () => ({
    updateCallTags: (conversationId, tags) => {
      setCallData(prevData =>
        prevData.map(c =>
          c.conversationId === conversationId ? { ...c, tags } : c
        )
      );
    },
    updateCallReview: (callId, reviewStatus) => {
      setCallData(prevData =>
        prevData.map(c =>
          c.callId === callId ? { ...c, reviewStatus } : c
        )
      );
    },
    updateCallEscalation: (callId, escalationStatus) => {
      setCallData(prevData =>
        prevData.map(c =>
          c.callId === callId ? { ...c, escalationStatus } : c
        )
      );
    }
  }));

  // With a status filter the whole (capped) result set is loaded once and paginated locally,
  // so page changes must not trigger a refetch.
  const fetchPage = selectedStatus ? 1 : currentPage;

  useEffect(() => {
    const fetchCallHistory = async () => {
      try {
        setLoading(true);
        setError(null);
        const params = selectedStatus
          ? { page: 0, size: STATUS_FILTER_FETCH_LIMIT }
          : { page: currentPage - 1, size: itemsPerPage };
        if (from) params.from = from;
        if (to) params.to = to;
        if (selectedAgent) params.agentId = selectedAgent;
        if (phoneQuery) params.phoneNumber = phoneQuery;
        if (selectedTag) params.tag = selectedTag;
        if (selectedReview) params.reviewStatus = selectedReview;
        if (selectedEscalation) params.humanEscalation = selectedEscalation === 'true';
        if (selectedEscalationStatus) params.escalationStatus = selectedEscalationStatus;
        const response = await api.get('/api/v1/dashboard/call-history', { params });

        if (response.data?.success && response.data?.data) {
          const data = response.data.data;
          const rows = selectedStatus
            ? (data.rows || []).filter((call) => matchesCallStatus(call.conversationStatus, selectedStatus))
            : (data.rows || []);
          const idOffset = selectedStatus ? 0 : (currentPage - 1) * itemsPerPage;
          const transformedData = rows.map((call, index) => ({
            id: `CALL-${idOffset + index + 1}`,
            callId: call.callId,
            conversationId: call.conversationId,
            dateTime: call.dateTime,
            customerName: call.customerName || 'NA',
            mobileNumber: call.mobileNumber,
            concernCategory: call.concernCategory || 'NA',
            conversationStatus: call.conversationStatus,
            callDuration: Math.round(call.callDurationMinutes * 60),
            recordingUrl: call.recordingUrl || '#',
            product: call.productName || 'NA',
            ticketId: null,
            tags: call.tags || [],
            reviewStatus: call.reviewStatus || 'NOT_MARKED',
            humanEscalation: call.humanEscalation || false,
            escalationStatus: call.escalationStatus || 'open',
            callSummary: call.callSummary,
            conversation: [],
            metadata: {
              orderId: null,
              customerType: call.customerName ? 'Repeat' : 'New',
              ticketsRaised: [],
              humanEscalation: call.humanEscalation ? 'Yes' : 'No',
              emailSent: false
            }
          }));

          setCallData(transformedData);
          setTotalCalls(selectedStatus ? transformedData.length : (data.totalCalls || 0));
          setStatusFilterCapped(!!selectedStatus && (data.totalCalls || 0) > STATUS_FILTER_FETCH_LIMIT);
        }
      } catch (err) {
        console.error('Error fetching call history:', err);
        setError('Failed to load call history data');
      } finally {
        setLoading(false);
      }
    };

    fetchCallHistory();
  }, [fetchPage, selectedAgent, phoneQuery, from, to, selectedTag, selectedReview, selectedEscalation, selectedEscalationStatus, selectedStatus]);

  // Reset page when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [selectedAgent, phoneQuery, from, to, selectedTag, selectedReview, selectedEscalation, selectedEscalationStatus, selectedStatus]);

  const handleRowClick = async (call) => {
    try {
      if (call.conversation?.length > 0) {
        onRowClick(call);
        return;
      }

      const response = await api.get(`/api/v1/dashboard/call-details/${call.callId}`);

      if (response.data?.success && response.data?.data) {
        const details = response.data.data;

        const conversation = details.conversationThread?.map(msg => ({
          sender: msg.speaker.toLowerCase(),
          text: msg.message,
          time: msg.time,
          sentiment: msg.sentiment
        })) || [];

        const enrichedCall = {
          ...call,
          conversation,
          tags: details.tags || call.tags || [],
          reviewStatus: details.reviewStatus || call.reviewStatus || 'NOT_MARKED',
          metadata: {
            orderId: details.orderId || null,
            customerType: details.customerType || 'New',
            ticketsRaised: details.ticketsRaised || [],
            humanEscalation: details.humanEscalation ? 'Yes' : 'No',
            emailSent: details.emailSent || false
          }
        };

        setCallData(prevData =>
          prevData.map(c => c.id === call.id ? enrichedCall : c)
        );

        onRowClick(enrichedCall);
      }
    } catch (err) {
      console.error('Error fetching call details:', err);
      onRowClick(call);
    }
  };

  const handlePlayPause = (e, url) => {
    e.stopPropagation();
    setPlayingUrl(prev => prev === url ? null : url);
  };

  const getStatusColor = (status) => {
    const colors = {
      'completed': 'bg-success/10 text-success border-success/20',
      'Resolved': 'bg-success/10 text-success border-success/20',
      'Escalated': 'bg-warning/10 text-warning border-warning/20',
      'Pending': 'bg-muted text-muted-foreground border-border',
      'busy': 'bg-error/10 text-error border-error/20',
      'Abandoned': 'bg-error/10 text-error border-error/20'
    };
    return colors?.[status] || colors?.Pending;
  };

  const getStatusIcon = (status) => {
    const icons = {
      'completed': 'CheckCircle2',
      'Resolved': 'CheckCircle2',
      'Escalated': 'ArrowUpCircle',
      'Pending': 'Clock',
      'busy': 'XCircle',
      'Abandoned': 'XCircle'
    };
    return icons?.[status] || 'Clock';
  };

  const handleSort = (key) => {
    setSortConfig({
      key,
      direction: sortConfig?.key === key && sortConfig?.direction === 'asc' ? 'desc' : 'asc'
    });
    setCurrentPage(1);
  };

  const sortedData = [...callData]?.sort((a, b) => {
    if (sortConfig?.key === 'dateTime') {
      return sortConfig?.direction === 'asc'
        ? new Date(a.dateTime) - new Date(b.dateTime)
        : new Date(b.dateTime) - new Date(a.dateTime);
    }
    if (sortConfig?.key === 'callDuration') {
      return sortConfig?.direction === 'asc'
        ? a?.callDuration - b?.callDuration
        : b?.callDuration - a?.callDuration;
    }
    if (sortConfig?.key === 'customerName') {
      return sortConfig?.direction === 'asc'
        ? a?.customerName?.localeCompare(b?.customerName)
        : b?.customerName?.localeCompare(a?.customerName);
    }
    return 0;
  });

  const totalPages = Math.ceil(totalCalls / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  // Server pages the data normally; with a status filter the filtered set is paged here
  const paginatedData = selectedStatus
    ? sortedData.slice(startIndex, startIndex + itemsPerPage)
    : sortedData;

  const formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}m ${secs}s`;
  };

  const formatDateTime = (dateTime) => {
    try {
      const date = new Date(dateTime + ' GMT');
      if (isNaN(date.getTime())) return dateTime;
      return date.toLocaleString('en-IN', {
        timeZone: 'Asia/Kolkata',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    } catch {
      return dateTime;
    }
  };

  const handleAddTag = async (callId, newTag) => {
    if (!newTag?.trim()) return;
    const call = callData?.find(c => c?.id === callId);
    if (!call) return;
    try {
      const response = await api.post(`/api/v1/conversations/${call.conversationId}/tags`, {
        tags: [newTag.trim()]
      });
      if (response.data?.success) {
        const addedTags = response.data?.data || [];
        setCallData(prevData =>
          prevData?.map(c =>
            c?.id === callId
              ? { ...c, tags: [...(c?.tags || []), ...addedTags] }
              : c
          )
        );
      }
    } catch (err) {
      console.error('Error adding tag:', err);
    } finally {
      setTagInput('');
      setEditingTag(null);
    }
  };

  const handleRemoveTag = async (callId, tagToRemove) => {
    const call = callData?.find(c => c?.id === callId);
    if (!call || !tagToRemove?.id) return;
    try {
      const response = await api.delete(`/api/v1/conversations/${call.conversationId}/tags`, {
        data: { tagIds: [tagToRemove.id] }
      });
      if (response.data?.success) {
        setCallData(prevData =>
          prevData?.map(c =>
            c?.id === callId
              ? { ...c, tags: c?.tags?.filter(tag => tag?.id !== tagToRemove.id) }
              : c
          )
        );
      }
    } catch (err) {
      console.error('Error removing tag:', err);
    }
  };

  const getNextReviewStatus = (current) => {
    const cycle = { NOT_MARKED: 'REVIEW_MARKED', REVIEW_MARKED: 'REVIEW_COMPLETED', REVIEW_COMPLETED: 'NOT_MARKED' };
    return cycle[current] || 'REVIEW_MARKED';
  };

  const getReviewDisplay = (status) => {
    const map = {
      REVIEW_MARKED: { label: 'Under Review', icon: 'ShieldAlert', className: 'bg-warning/10 text-warning border-warning/20' },
      REVIEW_COMPLETED: { label: 'Reviewed', icon: 'ShieldCheck', className: 'bg-success/10 text-success border-success/20' },
      NOT_MARKED: { label: 'Mark', icon: 'Shield', className: 'bg-muted text-muted-foreground border-border hover:bg-warning/10 hover:text-warning' }
    };
    return map[status] || map.NOT_MARKED;
  };

  const handleExport = async () => {
    try {
      const exportParams = { page: 0, size: totalCalls || 1000 };
      if (from) exportParams.from = from;
      if (to) exportParams.to = to;
      if (selectedAgent) exportParams.agentId = selectedAgent;
      if (phoneQuery) exportParams.phoneNumber = phoneQuery;
      if (selectedTag) exportParams.tag = selectedTag;
      if (selectedReview) exportParams.reviewStatus = selectedReview;
      if (selectedEscalation) exportParams.humanEscalation = selectedEscalation === 'true';
      if (selectedEscalationStatus) exportParams.escalationStatus = selectedEscalationStatus;
      const response = await api.get('/api/v1/dashboard/call-history', {
        params: exportParams
      });
      const rows = (response.data?.data?.rows || [])
        .filter((row) => matchesCallStatus(row.conversationStatus, selectedStatus));
      if (rows.length === 0) return;

      const headers = ['Date & Time (IST)', 'Customer Name', 'Mobile Number', 'Concern Category', 'Conversation Status', 'Call Duration (min)', 'Product', 'Review Status', 'Human Escalation', 'Escalation Status', 'Tags'];
      const csvRows = rows.map(row => [
        row.dateTime ? formatDateTime(row.dateTime) : '',
        row.customerName || '',
        row.mobileNumber || '',
        row.concernCategory || '',
        row.conversationStatus || '',
        row.callDurationMinutes != null ? row.callDurationMinutes.toFixed(2) : '',
        row.productName || '',
        row.reviewStatus || '',
        row.humanEscalation ? 'Yes' : 'No',
        row.escalationStatus || 'open',
        (row.tags || []).map(t => t.tag).join('; ')
      ]);

      const csvContent = [headers, ...csvRows]
        .map(row => row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(','))
        .join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `call-history-${new Date().toISOString().slice(0, 10)}.csv`;
      link.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Error exporting CSV:', err);
    }
  };

  const handleToggleReview = async (e, call) => {
    e.stopPropagation();
    const nextStatus = getNextReviewStatus(call.reviewStatus);
    try {
      const response = await api.put(
        `/api/v1/dashboard/call-details/${call.callId}/review-status`,
        null,
        { params: { status: nextStatus } }
      );
      if (response.data?.success) {
        setCallData(prevData =>
          prevData.map(c =>
            c.id === call.id ? { ...c, reviewStatus: nextStatus } : c
          )
        );
      }
    } catch (err) {
      console.error('Error updating review status:', err);
    }
  };

  const getEscalationStatusDisplay = (status) => {
    const map = {
      open: { label: 'Open', icon: 'ShieldAlert', className: 'bg-warning/10 text-warning border-warning/20' },
      closed: { label: 'Closed', icon: 'ShieldCheck', className: 'bg-success/10 text-success border-success/20' }
    };
    return map[status] || map.open;
  };

  const handleToggleEscalationStatus = async (e, call) => {
    e.stopPropagation();
    if (call.escalationStatus !== 'open') return;
    const nextStatus = 'closed';
    console.log('Escalation toggle clicked:', call.callId, call.escalationStatus, '->', nextStatus);
    try {
      const response = await api.put(
        `/api/v1/dashboard/call-details/${call.callId}/escalation-status`,
        null,
        { params: { status: nextStatus } }
      );
      console.log('Escalation API response:', response.data);
      if (response.data?.success) {
        setCallData(prevData =>
          prevData.map(c =>
            c.id === call.id ? { ...c, escalationStatus: nextStatus } : c
          )
        );
      }
    } catch (err) {
      console.error('Error updating escalation status:', err);
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-accent/10">
              <Icon name="Phone" size={20} className="text-accent" />
            </div>
            <div>
              <h3 className="text-base md:text-lg font-semibold text-foreground">Call History Log</h3>
              <p className="text-xs md:text-sm text-muted-foreground">
                {totalCalls} total calls
                {statusFilterCapped && (
                  <span className="ml-1 text-warning">
                    · status filter covers the latest {STATUS_FILTER_FETCH_LIMIT.toLocaleString('en-IN')} calls — narrow the date range for complete results
                  </span>
                )}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            <div className="relative">
              <Icon name="Search" size={14} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground" />
              <input
                type="text"
                placeholder="Search phone number"
                value={searchPhone}
                onChange={(e) => {
                  const val = e.target.value;
                  setSearchPhone(val);
                  clearTimeout(phoneTimerRef.current);
                  phoneTimerRef.current = setTimeout(() => {
                    setPhoneQuery(val.trim());
                    setCurrentPage(1);
                  }, 500);
                }}
                className="text-xs border border-border rounded-lg pl-8 pr-3 py-2 bg-card text-foreground focus:outline-none focus:ring-2 focus:ring-primary/20 w-44"
              />
            </div>

            {/* Date Range Dropdown */}
            <div className="relative" ref={dateRef}>
              <button
                onClick={() => setDateOpen(!dateOpen)}
                className="flex items-center gap-2 text-xs border border-border rounded-lg px-3 py-2 bg-card text-foreground hover:border-primary/40 focus:outline-none focus:ring-2 focus:ring-primary/20 min-w-[130px]"
              >
                <Icon name="Calendar" size={14} className="text-muted-foreground" />
                <span className="truncate">{selectedDateLabel}</span>
                <Icon name="ChevronDown" size={12} className="text-muted-foreground" />
              </button>
              {dateOpen && (
                <div className="absolute top-full right-0 mt-1 bg-card border border-border rounded-xl shadow-lg z-30 w-52 py-1">
                  {DATE_OPTIONS.map((opt) => (
                    <button
                      key={opt.value}
                      onClick={() => {
                        setDateRange(opt.value);
                        if (opt.value !== 'custom') setDateOpen(false);
                      }}
                      className={`w-full text-left px-4 py-2 text-sm hover:bg-primary/5 hover:text-primary transition-colors ${
                        dateRange === opt.value ? 'text-primary font-semibold bg-primary/5' : 'text-foreground'
                      }`}
                    >
                      {opt.label}
                    </button>
                  ))}
                  {dateRange === 'custom' && (
                    <div className="px-4 py-2 border-t border-border flex flex-col gap-2">
                      <input
                        type="date"
                        value={customFrom}
                        max={customTo || undefined}
                        onChange={(e) => setCustomFrom(e.target.value)}
                        className="w-full text-xs border border-border rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-primary/20"
                      />
                      <input
                        type="date"
                        value={customTo}
                        min={customFrom || undefined}
                        onChange={(e) => setCustomTo(e.target.value)}
                        className="w-full text-xs border border-border rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-primary/20"
                      />
                      <button
                        disabled={!customFrom || !customTo}
                        onClick={() => setDateOpen(false)}
                        className="w-full py-1.5 rounded-lg bg-primary text-primary-foreground text-xs font-semibold disabled:opacity-40 hover:bg-primary/90 transition-colors"
                      >
                        Apply
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
            <select
              value={selectedAgent}
              onChange={(e) => { setSelectedAgent(e.target.value); setCurrentPage(1); }}
              className="text-xs border border-border rounded-lg px-3 py-2 bg-card text-foreground focus:outline-none focus:ring-2 focus:ring-primary/20"
            >
              <option value="">All Agents</option>
              {agents.map((a) => (
                <option key={a.agentId} value={a.agentId}>{a.agentName}</option>
              ))}
            </select>
            <select
              value={selectedTag}
              onChange={(e) => { setSelectedTag(e.target.value); setCurrentPage(1); }}
              className="text-xs border border-border rounded-lg px-3 py-2 bg-card text-foreground focus:outline-none focus:ring-2 focus:ring-primary/20"
            >
              <option value="">All Tags</option>
              {tags.map((t) => (
                <option key={t} value={t}>{t}</option>
              ))}
            </select>
            <select
              value={selectedReview}
              onChange={(e) => { setSelectedReview(e.target.value); setCurrentPage(1); }}
              className="text-xs border border-border rounded-lg px-3 py-2 bg-card text-foreground focus:outline-none focus:ring-2 focus:ring-primary/20"
            >
              <option value="">All Reviews</option>
              <option value="NOT_MARKED">Not Marked</option>
              <option value="REVIEW_MARKED">Under Review</option>
              <option value="REVIEW_COMPLETED">Reviewed</option>
            </select>
            <select
              value={selectedEscalation}
              onChange={(e) => { setSelectedEscalation(e.target.value); setCurrentPage(1); }}
              className="text-xs border border-border rounded-lg px-3 py-2 bg-card text-foreground focus:outline-none focus:ring-2 focus:ring-primary/20"
            >
              <option value="">Escalations</option>
              <option value="true">Escalated</option>
              <option value="false">Not Escalated</option>
            </select>
            <select
              value={selectedEscalationStatus}
              onChange={(e) => { setSelectedEscalationStatus(e.target.value); setCurrentPage(1); }}
              className="text-xs border border-border rounded-lg px-3 py-2 min-w-[150px] bg-card text-foreground focus:outline-none focus:ring-2 focus:ring-primary/20"
            >
              <option value="">Esc. Status</option>
              <option value="open">Open</option>
              <option value="closed">Closed</option>
            </select>
            <select
              value={selectedStatus}
              onChange={(e) => { setSelectedStatus(e.target.value); setCurrentPage(1); }}
              className="text-xs border border-border rounded-lg px-3 py-2 min-w-[150px] bg-card text-foreground focus:outline-none focus:ring-2 focus:ring-primary/20"
            >
              <option value="">Call Status</option>
              {CALL_STATUS_OPTIONS.map((o) => (
                <option key={o.value} value={o.value}>{o.label}</option>
              ))}
            </select>
            <Button variant="outline" size="sm" iconName="Download" iconPosition="left" onClick={handleExport}>
              Export
            </Button>
          </div>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50">
            <tr>
              <th className="px-4 md:px-6 py-3 text-left">
                <span className="text-xs font-medium text-muted-foreground">Call ID</span>
              </th>
              <th className="px-4 md:px-6 py-3 text-left">
                <button
                  onClick={() => handleSort('dateTime')}
                  className="flex items-center gap-2 text-xs font-medium text-muted-foreground hover:text-foreground transition-base"
                >
                  Date & Time
                  <Icon name={sortConfig?.key === 'dateTime' && sortConfig?.direction === 'asc' ? 'ChevronUp' : 'ChevronDown'} size={14} />
                </button>
              </th>
              <th className="px-4 md:px-6 py-3 text-left">
                <button
                  onClick={() => handleSort('customerName')}
                  className="flex items-center gap-2 text-xs font-medium text-muted-foreground hover:text-foreground transition-base"
                >
                  Customer Name
                  <Icon name={sortConfig?.key === 'customerName' && sortConfig?.direction === 'asc' ? 'ChevronUp' : 'ChevronDown'} size={14} />
                </button>
              </th>
              <th className="px-4 md:px-6 py-3 text-left">
                <span className="text-xs font-medium text-muted-foreground">Mobile Number</span>
              </th>
              <th className="px-4 md:px-6 py-3 text-left">
                <span className="text-xs font-medium text-muted-foreground">Concern Category</span>
              </th>
              <th className="px-4 md:px-6 py-3 text-left">
                <span className="text-xs font-medium text-muted-foreground">Conversation Status</span>
              </th>
              <th className="px-4 md:px-6 py-3 text-left">
                <button
                  onClick={() => handleSort('callDuration')}
                  className="flex items-center gap-2 text-xs font-medium text-muted-foreground hover:text-foreground transition-base"
                >
                  Call Duration
                  <Icon name={sortConfig?.key === 'callDuration' && sortConfig?.direction === 'asc' ? 'ChevronUp' : 'ChevronDown'} size={14} />
                </button>
              </th>
              <th className="px-4 md:px-6 py-3 text-left">
                <span className="text-xs font-medium text-muted-foreground">Recording</span>
              </th>
              {/* <th className="px-4 md:px-6 py-3 text-left">
                <span className="text-xs font-medium text-muted-foreground">Product</span>
              </th> */}
              <th className="px-4 md:px-6 py-3 text-left">
                <span className="text-xs font-medium text-muted-foreground">Ticket ID</span>
              </th>
              <th className="px-4 md:px-6 py-3 text-left">
                <span className="text-xs font-medium text-muted-foreground">Tags</span>
              </th>
              <th className="px-4 md:px-6 py-3 text-center">
                <span className="text-xs font-medium text-muted-foreground">Needs Review</span>
              </th>
              <th className="px-4 md:px-6 py-3 text-center">
                <span className="text-xs font-medium text-muted-foreground">Escalated</span>
              </th>
              <th className="px-4 md:px-6 py-3 text-center">
                <span className="text-xs font-medium text-muted-foreground">Escalation Status</span>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {loading ? (
              <tr>
                <td colSpan="13" className="px-4 py-8">
                  <div className="flex items-center justify-center gap-3">
                    <div className="w-5 h-5 border-2 border-primary border-t-transparent rounded-full animate-spin"></div>
                    <span className="text-muted-foreground">Loading call history...</span>
                  </div>
                </td>
              </tr>
            ) : error ? (
              <tr>
                <td colSpan="13" className="px-4 py-8">
                  <div className="flex flex-col items-center justify-center gap-4">
                    <Icon name="AlertCircle" size={48} className="text-error" />
                    <div className="text-center">
                      <p className="text-foreground font-medium mb-1">Failed to load call history</p>
                      <p className="text-sm text-muted-foreground">{error}</p>
                    </div>
                    <Button onClick={() => window.location.reload()} variant="outline" size="sm">
                      Retry
                    </Button>
                  </div>
                </td>
              </tr>
            ) : paginatedData?.map((call) => (
              <tr
                key={call?.id}
                onClick={() => handleRowClick(call)}
                className="hover:bg-muted/30 transition-base cursor-pointer"
              >
                <td className="px-4 md:px-6 py-4">
                  <span className="text-xs font-mono text-muted-foreground whitespace-nowrap">{call?.callId}</span>
                </td>
                <td className="px-4 md:px-6 py-4">
                  <span className="text-sm text-foreground whitespace-nowrap">{formatDateTime(call?.dateTime)}</span>
                </td>
                <td className="px-4 md:px-6 py-4">
                  <span className="text-sm font-medium text-foreground">{call?.customerName}</span>
                </td>
                <td className="px-4 md:px-6 py-4">
                  <span className="text-sm text-foreground whitespace-nowrap">{call?.mobileNumber}</span>
                </td>
                <td className="px-4 md:px-6 py-4">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-muted text-xs font-medium text-foreground">
                    {call?.concernCategory}
                  </span>
                </td>
                <td className="px-4 md:px-6 py-4">
                  <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-medium ${getStatusColor(call?.conversationStatus)}`}>
                    <Icon name={getStatusIcon(call?.conversationStatus)} size={12} />
                    {call?.conversationStatus}
                  </span>
                </td>
                <td className="px-4 md:px-6 py-4">
                  <span className="text-sm text-foreground whitespace-nowrap">{formatDuration(call?.callDuration)}</span>
                </td>

                {/* ── Recording cell ── */}
                <td className="px-4 md:px-6 py-4" onClick={(e) => e.stopPropagation()}>
                  {call?.recordingUrl && call?.recordingUrl !== '#' ? (
                    <div className="flex flex-col gap-2">
                      <button
                        onClick={(e) => handlePlayPause(e, call.recordingUrl)}
                        className="flex items-center justify-center w-8 h-8 rounded-lg bg-primary/10 hover:bg-primary hover:text-primary-foreground transition-base"
                        aria-label={playingUrl === call.recordingUrl ? 'Stop recording' : 'Play recording'}
                      >
                        <Icon name={playingUrl === call.recordingUrl ? 'Square' : 'Play'} size={14} />
                      </button>

                      {playingUrl === call.recordingUrl && (
                        <audio
                          key={call.recordingUrl}
                          controls
                          autoPlay
                          src={call.recordingUrl}
                          onEnded={() => setPlayingUrl(null)}
                          onError={() => setPlayingUrl(null)}
                          className="w-48 h-8"
                        />
                      )}
                    </div>
                  ) : (
                    <span className="text-sm text-muted-foreground">-</span>
                  )}
                </td>

                {/* <td className="px-4 md:px-6 py-4">
                  <span className="text-sm text-foreground">{call?.product}</span>
                </td> */}
                <td className="px-4 md:px-6 py-4">
                  {call?.ticketId ? (
                    <span className="text-sm font-mono text-primary">{call?.ticketId}</span>
                  ) : (
                    <span className="text-sm text-muted-foreground">-</span>
                  )}
                </td>
                <td className="px-4 md:px-6 py-4">
                  <div className="flex flex-wrap gap-1">
                    {call?.tags?.map((tag) => (
                      <span
                        key={tag?.id}
                        className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-primary/10 text-primary text-xs"
                      >
                        {tag?.tag}
                        <button
                          onClick={(e) => {
                            e?.stopPropagation();
                            handleRemoveTag(call?.id, tag);
                          }}
                          className="hover:text-error transition-base"
                        >
                          <Icon name="X" size={10} />
                        </button>
                      </span>
                    ))}
                    {editingTag === call?.id ? (
                      <input
                        type="text"
                        value={tagInput}
                        onChange={(e) => setTagInput(e?.target?.value)}
                        onKeyDown={(e) => {
                          if (e?.key === 'Enter') handleAddTag(call?.id, tagInput);
                          if (e?.key === 'Escape') {
                            setEditingTag(null);
                            setTagInput('');
                          }
                        }}
                        onBlur={() => {
                          if (tagInput?.trim()) {
                            handleAddTag(call?.id, tagInput);
                          } else {
                            setEditingTag(null);
                          }
                        }}
                        onClick={(e) => e?.stopPropagation()}
                        className="w-20 px-2 py-0.5 text-xs border border-border rounded-full focus:outline-none focus:ring-2 focus:ring-primary"
                        placeholder="New tag"
                        autoFocus
                      />
                    ) : (
                      <button
                        onClick={(e) => {
                          e?.stopPropagation();
                          setEditingTag(call?.id);
                        }}
                        className="flex items-center justify-center w-5 h-5 rounded-full bg-muted hover:bg-primary hover:text-primary-foreground transition-base"
                      >
                        <Icon name="Plus" size={10} />
                      </button>
                    )}
                  </div>
                </td>
                <td className="px-4 md:px-6 py-4 text-center">
                  {(() => {
                    const display = getReviewDisplay(call?.reviewStatus);
                    return (
                      <button
                        onClick={(e) => handleToggleReview(e, call)}
                        className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-medium transition-base ${display.className}`}
                      >
                        <Icon name={display.icon} size={12} />
                        {display.label}
                      </button>
                    );
                  })()}
                </td>
                <td className="px-4 md:px-6 py-4 text-center">
                  {call?.humanEscalation ? (
                    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-medium bg-warning/10 text-warning border-warning/20">
                      <Icon name="ShieldAlert" size={12} />
                      Yes
                    </span>
                  ) : (
                    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-medium bg-muted text-muted-foreground border-border">
                      <Icon name="Shield" size={12} />
                      No
                    </span>
                  )}
                </td>
                <td className="px-4 md:px-6 py-4 text-center">
                  {call?.humanEscalation ? (() => {
                    const display = getEscalationStatusDisplay(call?.escalationStatus);
                    return call?.escalationStatus === 'open' ? (
                      <button
                        onClick={(e) => handleToggleEscalationStatus(e, call)}
                        className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-medium transition-base cursor-pointer hover:opacity-80 ${display.className}`}
                      >
                        <Icon name={display.icon} size={12} />
                        {display.label}
                      </button>
                    ) : (
                      <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-medium ${display.className}`}>
                        <Icon name={display.icon} size={12} />
                        {display.label}
                      </span>
                    );
                  })() : (
                    <span className="text-sm text-muted-foreground">-</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>

        </table>
      </div>

      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 p-4 md:p-6 border-t border-border">
        <p className="text-sm text-muted-foreground">
          Showing {startIndex + 1} to {Math.min(startIndex + itemsPerPage, totalCalls)} of {totalCalls} calls
        </p>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
            disabled={currentPage === 1}
          >
            <Icon name="ChevronLeft" size={16} />
          </Button>
          <div className="flex items-center gap-1">
            {(() => {
              const pages = [];
              for (let i = 1; i <= totalPages; i++) {
                if (i <= 2 || i === totalPages || (i >= currentPage - 1 && i <= currentPage + 1)) {
                  pages.push(i);
                } else if (pages[pages.length - 1] !== '...') {
                  pages.push('...');
                }
              }
              return pages.map((p, idx) =>
                p === '...' ? (
                  <span key={`dots-${idx}`} className="w-8 h-8 flex items-center justify-center text-sm text-muted-foreground">...</span>
                ) : (
                  <button
                    key={p}
                    onClick={() => setCurrentPage(p)}
                    className={`w-8 h-8 rounded-lg text-sm font-medium transition-base ${
                      currentPage === p
                        ? 'bg-primary text-primary-foreground'
                        : 'bg-muted text-muted-foreground hover:bg-primary/10'
                    }`}
                  >
                    {p}
                  </button>
                )
              );
            })()}
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
            disabled={currentPage === totalPages}
          >
            <Icon name="ChevronRight" size={16} />
          </Button>
        </div>
      </div>
    </div>
  );
});

export default CallHistoryLogTable;